module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "live-feed"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Livefeed teste")]), _c('div', {
    staticClass: "spacer-10"
  }), (!_vm.current_user.isSeller()) ? _c('div', {
    staticClass: "filters"
  }, [_c('dropdown-select', {
    attrs: {
      "options": _vm.users_options
    },
    on: {
      "input": _vm.loadLiveFeedEvents
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "spacer-10"
  }), (_vm.loading) ? _c('div', {
    staticClass: "loading loading-spacer",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "events-list",
    class: {
      "less-space": _vm.current_user.isSeller()
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.events), function(event) {
    return _c('live-feed-event-list-item', {
      key: event.id,
      attrs: {
        "event": event
      },
      on: {
        "toggle-task-bar": _vm.bubbleUp
      }
    })
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d732263!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/live_feed.vue
// module id = 1108
// module chunks = 1